import React from 'react'
import { TabsWrapper } from '../../libs/react-mpk/wrapper'
import { inject, observer } from 'mobx-react'
import TableBuktiPotong from '../TableBuktiPotong'
import { useParams } from 'react-router'


const BuktiPotong = ({ 
  className         = '',
  navigationStore, 
  envStore,
}) => {
  let{ companyId } = useParams()
  return (

    <TabsWrapper
      title="Bukti Potong"
      baseId="mod-details-sample"
      className={className}
      tabs={[
        {
          label: 'All',
          key: 'all',
          render: (
            <TableBuktiPotong 
              showCommandbar={false}
            />
          )
        },
        {
          label: 'Belum Lapor',
          key: 'belumLapor',
          render: (
            <TableBuktiPotong 
              showCommandbar={false}
              fgLapor="Belum Lapor"
            />
          )
        },
        {
          label: 'Sudah Lapor',
          key: 'sudahLapor',
          render: (
            <TableBuktiPotong 
              showCommandbar={false}
              fgLapor="Sudah Lapor"
            />
          )
        },
      ]}
      onChange={(tab, callback) => {
        navigationStore.redirectTo(`/${envStore.env.applicationType}/company/${companyId}/details/${tab.key}`)
        callback()
      }}
    />
  )
}

export default inject('navigationStore', 'envStore')(observer(BuktiPotong))
